export default __webpack_public_path__ + "static/media/Logo.29e8c62d.svg";